import React from 'react';
import styles from './WhatsAppButton.module.css';

const WhatsAppButton = () => {
  const phoneNumber = '50377437046'; // Reemplaza con tu número de WhatsApp
  // Crear URL de WhatsApp Web sin mensaje automático
  // Formato: https://wa.me/[número]
  // El número debe incluir el código de país (ej: 50367123456 para El Salvador)
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <div className={styles.whatsappButtonContainer}>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.whatsappButton}
        title="Contacta con nosotros por WhatsApp"
      >
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
          alt="WhatsApp" 
          className={styles.whatsappIcon}
        />
        <div className={styles.whatsappInfo}>
          <p className={styles.label}>Contáctanos</p>
          <p className={styles.phone}>{phoneNumber.replace(/(\d{3})(\d{4})(\d{2})/, '+$1 $2-$3')}</p>
        </div>
      </a>
    </div>
  );
};

export default WhatsAppButton;
